/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
export type SuspectedTradeUserLoader_user$ref = any;
export type SuspectedTradeUserLoader_user = {
    readonly verifiedTradeStatus: string | null;
    readonly serviceId: string | null;
    readonly " $refType": SuspectedTradeUserLoader_user$ref;
};



const node: ReaderFragment = ({
    "kind": "Fragment",
    "name": "SuspectedTradeUserLoader_user",
    "type": "User",
    "metadata": null,
    "argumentDefinitions": [],
    "selections": [
        {
            "kind": "ScalarField",
            "alias": null,
            "name": "verifiedTradeStatus",
            "args": null,
            "storageKey": null
        },
        {
            "kind": "ScalarField",
            "alias": null,
            "name": "serviceId",
            "args": null,
            "storageKey": null
        }
    ]
} as any);
(node as any).hash = '8a0d18fef0fe4f6bfe109dc249ac5913';
export default node;
